import React from 'react';
import { GlobeIcon, UsersIcon, PhoneIcon, ZapIcon, HardDriveIcon, ClipboardCheckIcon } from 'lucide-react';
const services = [{
  title: 'Websites & Hosting',
  description: 'Launch or improve your business website with scalable hosting, landing pages, and support for future growth.',
  icon: GlobeIcon
}, {
  title: 'CRM & Client Management',
  description: 'Organize leads, contacts, appointments, client requests, and follow-ups in one connected business workflow.',
  icon: UsersIcon
}, {
  title: 'VoIP & Business Communication',
  description: 'Prepare your business for professional phone, messaging, and communication tools designed for client-facing operations.',
  icon: PhoneIcon
}, {
  title: 'Automation & Digital Workflow',
  description: 'Reduce repetitive tasks with automated forms, notifications, onboarding steps, and service request flows.',
  icon: ZapIcon
}, {
  title: 'Cloud Storage & Media Support',
  description: 'Support business files, media uploads, documents, and scalable content storage through cloud-based infrastructure.',
  icon: HardDriveIcon
}, {
  title: 'Support & Client Intake',
  description: 'Create a smoother experience for customers through intake forms, service requests, support tickets, and guided onboarding.',
  icon: ClipboardCheckIcon
}];
export function ServicesPreview() {
  return <section id="services" className="py-24 bg-white" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-198">
            Built for the Way Small Businesses Work
          </h2>
          <div className="w-20 h-1.5 bg-blue-600 mx-auto rounded-full" data-id="element-199"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-200">
          {services.map((service, index) => <div key={index} className="p-8 rounded-3xl border border-slate-100 bg-slate-50/50 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all group" data-id="element-201">
              <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm group-hover:bg-blue-600 transition-colors" data-id="element-202">
                <service.icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" data-id="element-203" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-204">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-205">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}